import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getExtrasUseCase } from '@/core/domain/extras/usecases/getExtras.usecase';
import { ExtrasRepository } from '@/core/domain/extras/repositories/extras.repository';
import { ExtrasImplRepository } from './extras-impl.repository';

const getExtrasUseCaseFactory = (extrasRepository: ExtrasRepository) =>
    new getExtrasUseCase(extrasRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: getExtrasUseCase,
            useFactory: getExtrasUseCaseFactory,
            deps: [ExtrasRepository],
        },
        {
            provide: ExtrasRepository,
            useClass: ExtrasImplRepository,
        },
    ],
})
export class ExtrasDataModule {}
